// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"d3825a96","828":"89358f49"}[chunkId] + ".chunk.js";
};